/**
 * 工具栏的常量表：字体、字号、行距、调色板、段落样式。
 * 取值对齐 Google Docs 的默认列表，字体只用系统字体（不引外部 Web Font，保持 CSP self 与离线可用）。
 */

export type BlockStyle = {
  value: string
  label: string
  /** 下拉里预览用的 class */
  previewClass: string
  /** 1-6 表示标题级别，null 表示普通段落 */
  level: 1 | 2 | 3 | 4 | 5 | 6 | null
}

export const BLOCK_STYLES: BlockStyle[] = [
  { value: 'paragraph', label: '普通文本', previewClass: 'style-plain', level: null },
  { value: 'heading-1', label: '标题 1', previewClass: 'style-h1', level: 1 },
  { value: 'heading-2', label: '标题 2', previewClass: 'style-h2', level: 2 },
  { value: 'heading-3', label: '标题 3', previewClass: 'style-h3', level: 3 },
  { value: 'heading-4', label: '标题 4', previewClass: 'style-h4', level: 4 },
  { value: 'heading-5', label: '标题 5', previewClass: 'style-h5', level: 5 },
  { value: 'heading-6', label: '标题 6', previewClass: 'style-h6', level: 6 },
]

export const FONT_FAMILIES: Array<{ label: string; value: string }> = [
  { label: 'Arial', value: 'Arial' },
  { label: 'Calibri', value: 'Calibri' },
  { label: 'Cambria', value: 'Cambria' },
  { label: 'Comic Sans MS', value: 'Comic Sans MS' },
  { label: 'Courier New', value: 'Courier New' },
  { label: 'Georgia', value: 'Georgia' },
  { label: 'Helvetica', value: 'Helvetica' },
  { label: 'Impact', value: 'Impact' },
  { label: 'Times New Roman', value: 'Times New Roman' },
  { label: 'Trebuchet MS', value: 'Trebuchet MS' },
  { label: 'Verdana', value: 'Verdana' },
  { label: '宋体', value: 'SimSun' },
  { label: '黑体', value: 'SimHei' },
  { label: '微软雅黑', value: 'Microsoft YaHei' },
  { label: '楷体', value: 'KaiTi' },
  { label: '仿宋', value: 'FangSong' },
  { label: '等宽', value: 'ui-monospace' },
]

export const FONT_SIZE_PRESETS = [8, 9, 10, 11, 12, 14, 18, 24, 30, 36, 48, 60, 72, 96]

export const LINE_HEIGHT_PRESETS = [
  { value: '1', label: '单倍行距 (1.0)' },
  { value: '1.15', label: '1.15' },
  { value: '1.5', label: '1.5' },
  { value: '2', label: '双倍行距 (2.0)' },
]

/** Google Docs 的经典调色板 */
export const TEXT_COLORS: string[][] = [
  ['#000000', '#434343', '#666666', '#999999', '#b7b7b7', '#cccccc', '#d9d9d9', '#efefef', '#f3f3f3', '#ffffff'],
  ['#980000', '#ff0000', '#ff9900', '#ffff00', '#00ff00', '#00ffff', '#4a86e8', '#0000ff', '#9900ff', '#ff00ff'],
  ['#e6b8af', '#f4cccc', '#fce5cd', '#fff2cc', '#d9ead3', '#d0e0e3', '#c9daf8', '#cfe2f3', '#d9d2e9', '#ead1dc'],
  ['#dd7e6b', '#ea9999', '#f9cb9c', '#ffe599', '#b6d7a8', '#a2c4c9', '#a4c2f4', '#9fc5e8', '#b4a7d6', '#d5a6bd'],
  ['#cc4125', '#e06666', '#f6b26b', '#ffd966', '#93c47d', '#76a5af', '#6d9eeb', '#6fa8dc', '#8e7cc3', '#c27ba0'],
  ['#a61c00', '#cc0000', '#e69138', '#f1c232', '#6aa84f', '#45818e', '#3c78d8', '#3d85c6', '#674ea7', '#a64d79'],
]

export const HIGHLIGHT_COLORS: string[][] = [
  ['#ffff00', '#00ff00', '#00ffff', '#ff00ff', '#4a86e8', '#ff0000'],
  ['#fff2cc', '#d9ead3', '#d0e0e3', '#ead1dc', '#f4cccc', '#fce5cd'],
  ['#ffe599', '#b6d7a8', '#a2c4c9', '#d5a6bd', '#ea9999', '#f9cb9c'],
]
